export var de = {
  formats: {
    date: "dd.mm.yyyy"
  },
  texts: {
    lsg: {
      component: {
        _general: {
          optional: "Optional"
        },
        BankingCard: {
          titles: {
            giro: "Girocard",
            info: "Infocard",
            spar: "Sparcard",
            flexi: "Flexicard",
            einzahl: "Einzahlcard"
          },
          cardNumber: "Karten-Nr.",
          validThru: "Gültig bis"
        },
        BreadCrumbs: {
          title: "Seitenhierarchie"
        },
        ComplexTable: {
          sortAscending: "Aufsteigend sortieren",
          sortDescending: "Absteigend sortieren",
          sortedAscending: "Aufsteigend sortiert",
          sortedDescending: "Absteigend sortiert"
        },
        ContentWrapper: {
          closeLayer: "zurück zur Übersicht",
          showDetails: "Details anzeigen"
        },
        Feedback: {
          trueButton: "Ja",
          falseButton: "Nein",
          result: "Vielen Dank für Ihr Feedback."
        },
        IconLink: {
          defaultAriaLabel: "Button mit {{label}} Symbol"
        },
        InputDatepicker: {
          placeholder: "TT.MM.JJJJ",
          label: "Datum",
          error: "Bitte geben Sie ein gültiges Datum im Format {{format}} ein.",
          openCalendar: "Kalender öffnen",
          nextMonth: "nächster Monat",
          previousMonth: "vorheriger Monat"
        },
        InputSelect: {
          error: "Bitte wählen Sie eine Option aus.",
          open: "Auswählfeld öffnen",
          close: "Auswählfeld schließen"
        },
        InputTextfield: {
          clear: "Eingabe löschen",
          reveal: "Passwort anzeigen"
        },
        InputSearch: {
          placeholder: "Suche",
          clear: "Suche zurücksetzen"
        },
        SideNavigation: {
          openMenu: "Menü öffnen",
          closeMenu: "Menü schließen"
        },
        SliderPagination: {
          nextPage: "nächste Seite",
          previousPage: "vorherige Seite",
          pagination: "Seitenauswahl"
        },
        Stage: {
          scrollerText: "Hier weiterlesen..."
        },
        Header: {
          myBanking: "Mein Banking",
          search: "Suche",
          openMenu: "Menü öffnen",
          closeDrawer: "Menü schließen"
        },
        ProcessHeader: {
          openMenu: "Menü öffnen"
        }
      },
      icon: {
        _default: "Icon",
        banking_banknote_euro: "Banknote Euro",
        banking_creditcard_multiple: "Kreditkarten",
        banking_graphs_graph: "Graph",
        banking_atm: "Bankautomat",
        banking_transferslip: "Überweisungszettel",
        basics_eye_view: "Auge",
        basics_people_group: "Gruppe von Menschen",
        basics_person_female: "Person weiblich",
        basics_person_male: "Person männlich",
        basics_person_profile: "Profil",
        basics_person_wheelchair: "Rollstuhl",
        basics_settings_gear: "Zahnrad",
        basics_arrow: "Pfeil",
        basics_calender: "Kalender",
        basics_checklist: "Checkliste",
        basics_checkmark: "Häkchen",
        basics_clock: "Uhr",
        interaction___close: "Schließen",
        basics_download: "Download",
        basics_error: "Fehler",
        basics_exclamationmark: "Ausrufezeichen",
        basics_fingerprint: "Fingerabdruck",
        basics_house: "Haus",
        symbols___infoCircle: "Info Symbol",
        basics_info: "Info",
        basics_legal: "Paragraph",
        basics_lightbulb: "Glühbirne",
        basics_lock: "Schloss",
        basics_music: "Musik-Noten",
        basics_paperclip: "Büroklammer",
        basics_pencil: "Bleistift",
        basics_percentage: "Prozent",
        basics_playbutton: "Abspielen",
        basics_questionmark: "Fragezeichen",
        basics_refresh: "Aktualisieren",
        basics_search: "Suche",
        basics_shoppingcart: "Einkaufswagen",
        basics_upload: "Upload",
        basics_volume: "Lautstärke",
        communication_feedback_like: "Feedback Like",
        communication_mail_envelope: "Briefumschlag",
        communication_wifi_on: "Wifi",
        communication_call: "Telefonhörer",
        communication_chat: "Chat",
        communication_textchat: "Text-Chat",
        devices_headset: "Headset",
        devices_laptop: "Laptop",
        devices_smartphone: "Smartphone",
        devices_tablet: "Tablet",
        location_globe: "Weltkugel",
        location_location: "Standort",
        basics_arrows_arrow_d: "Pfeil nach unten",
        interaction_arrows_arrowLeft: "Pfeil links",
        basics_arrows_arrow_r: "Pfeil rechts",
        basics_arrows_arrow_u: "Pfeil hoch",
        basics_arrows_chevron_d: "Pfeil nach unten",
        interaction_arrows_chevronLeft: "Pfeil links",
        basics_arrows_chevron_r: "Pfeil rechts",
        basics_arrows_chevron_u: "Pfeil hoch",
        basics_add: "Plus",
        basics_menu: "Menü",
        communication_rating_happy: "Emoticon zufrieden",
        communication_rating_neutral: "Emoticon neutral",
        communication_rating_sad: "Emoticon unzufrieden",
        social_cobablog: "Coba Blog",
        social_facebook: "Facebook",
        social_instagram: "Instagram",
        social_linkedin: "LinkedIn",
        social_twitter: "Twitter",
        social_xing: "Xing",
        social_youtube: "Youtube"
      }
    }
  }
};